import React, { FunctionComponent } from "react"
import { Line } from "react-chartjs-2"
import { ChartData, ChartOptions, DefaultDataPoint } from "chart.js"
import { weibullSample } from "@components/Distribution/WeibullDistributionChart/weibull.calc"

interface Props {
  c: number
  loc: number
  scale: number
  lbound?: number
  ubound?: number
}

export const WeibullDistributionChart: FunctionComponent<Props> = ({
  c = 0,
  loc = 0,
  scale = 1,
  lbound = undefined,
  ubound = undefined,
}) => {
  const { labels, data } = weibullSample(c, scale, loc, lbound, ubound)

  const chartData: ChartData<"line", DefaultDataPoint<"line">, number> = {
    labels,
    datasets: [
      {
        data,
        fill: true,
        tension: 0.4,
      },
    ],
  }
  const chartOptions: ChartOptions<"line"> = {
    responsive: true,
    maintainAspectRatio: true,
    scales: {
      x: {
        title: {
          display: true,
          text: "Value",
        },
      },
      y: {
        title: {
          display: true,
          text: "Probability Density",
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
    },
  }
  return <Line options={chartOptions} data={chartData}></Line>
}
